import $ from "jquery";

const colorSchemes = ["colorLight", "colorSepia", "colorDark"];

/** The reader's colour scheme, as the body class that applies it */
export const get = () => localStorage.getItem("reader.color") ?? "colorSepia";

export const set = (colorScheme: string) =>
  localStorage.setItem("reader.color", colorScheme);

/** Applied as soon as the reader page opens, so it loads in its own colours */
export const applyToBody = () => {
  $("body").removeClass(colorSchemes.join(" ")).addClass(get());
};
